/**
 * 休日種別API クライアント
 */

import { authFetch, API_BASE_URL } from "./client";

export interface DayOffTypeResponse {
    id: number;
    tenant_id: string;
    code: string;
    name: string;
    short_name: string | null;
    description: string | null;
    text_color: string;
    background_color: string | null;
    is_system: number;
    is_work_time: number;
    day_count_type: number;
    // 自動作成バッチ専用フラグ（連勤/連休/月間公休/月間勤務時間カウント）
    autogen_count_in_consecutive_workdays: number;
    autogen_count_in_consecutive_days_off: number;
    autogen_count_in_day_off_count: number;
    autogen_count_in_working_hours_monthly: number;
    created_at: string;
    updated_at: string;
}

export interface DayOffTypeListResponse {
    items: DayOffTypeResponse[];
    total: number;
}

export interface DayOffTypeCreateRequest {
    code: string;
    name: string;
    short_name?: string | null;
    description?: string | null;
    text_color?: string | null;
    background_color?: string | null;
    is_work_time?: number;
    day_count_type?: number;
    autogen_count_in_consecutive_workdays?: number;
    autogen_count_in_consecutive_days_off?: number;
    autogen_count_in_day_off_count?: number;
    autogen_count_in_working_hours_monthly?: number;
}

export interface DayOffTypeUpdateRequest {
    code?: string;
    name?: string;
    short_name?: string | null;
    description?: string | null;
    text_color?: string | null;
    background_color?: string | null;
    is_work_time?: number;
    day_count_type?: number;
    autogen_count_in_consecutive_workdays?: number;
    autogen_count_in_consecutive_days_off?: number;
    autogen_count_in_day_off_count?: number;
    autogen_count_in_working_hours_monthly?: number;
}

export async function fetchDayOffTypes(): Promise<DayOffTypeListResponse> {
    const response = await authFetch(`${API_BASE_URL}/day-off-types`);
    if (!response.ok) throw new Error(`Failed to fetch day off types: ${response.status}`);
    return response.json();
}

export async function createDayOffType(data: DayOffTypeCreateRequest): Promise<DayOffTypeResponse> {
    const response = await authFetch(`${API_BASE_URL}/day-off-types`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`Failed to create day off type: ${response.status}`);
    return response.json();
}

export async function updateDayOffType(id: number, data: DayOffTypeUpdateRequest): Promise<DayOffTypeResponse> {
    const response = await authFetch(`${API_BASE_URL}/day-off-types/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`Failed to update day off type: ${response.status}`);
    return response.json();
}

export async function deleteDayOffType(id: number): Promise<void> {
    const response = await authFetch(`${API_BASE_URL}/day-off-types/${id}`, {
        method: "DELETE",
    });
    if (!response.ok) throw new Error(`Failed to delete day off type: ${response.status}`);
}
